import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 获取预约列表
export function getManOrderList(data) {
  const { start, end, ...params } = data
  return request.get('/personOrder/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end
    }
  })
}

// 创建人员预约信息
export function createManOrderOne(data) {
  return request.post('/personOrder/create', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 人员预约审核
export function updateManOrderOne(data) {
  const { id, ...params } = data
  const url = '/personOrder/check/' + id
  return request.get(url, { params })
}

// 获取预约列表
// export function getCarOrderList(data) {
//   const { start, end, ...params } = data
//   return request.get('/carOrderRecord/list', {
//     params: {
//       ...params,
//       startDate: start,
//       endDate: end
//     }
//   })
// }
export function getCarOrderList(data) {
  return request.post('/carOrderRecord/getPage', data)
}

// 创建货车预约信息
export function createCarOrderOne(data) {
  return request.post('/carOrderRecord/create', data)
}

// 货车预约审核
export function updateCarOrderOne(data) {
  const { id, ...params } = data
  const url = '/carOrderRecord/check/' + id
  return request.get(url, { params })
}

// 获取预约列表
export function getTruckOrderList(data) {
  const { start, end, ...params } = data
  return request.get('/truckOrder/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end
    }
  })
}

// 创建货车预约信息
export function createTruckOrderOne(data) {
  return request.post('/truckOrder/create', data)
}

// 货车预约审核
export function updateTruckOrderOne(data) {
  const { id, ...params } = data
  const url = '/truckOrder/check/' + id
  return request.get(url, { params })
}
